import * as Sentry from "@sentry/react";
//new
export const initSentry = () => {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,

    integrations: [
      Sentry.browserTracingIntegration(),

      Sentry.replayIntegration(),

      Sentry.captureConsoleIntegration({
        levels: ["error"],
      }),
    ],

    tracesSampleRate: 0.1,

    replaysSessionSampleRate: 0.02,

    replaysOnErrorSampleRate: 1.0,
  });
};
